import {Avatar, Badge, Skeleton, Typography,} from "@mui/material";
import {ViewPopup} from "components/Admin/Pages/ViewPopup/ViewPopup";
import React from "react";
import {Label} from "../../../components/Label/Label";
import {collectionService} from "../../../services/collectionService";
import {Reference} from "../../../components/Reference/Reference";
import {seasonService} from "../../../services/seasonService";
import Link from '@mui/material/Link';
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import {CapAddButton} from "./components/CapAddButton/CapAddButton";
import {useNavigate} from "react-router";
import {Query} from "../../../components/Query/Query";
import {capService} from "../../../services/capService";
import {CapType} from "../../../dto/cap-dto";

const typeOrder = {
    [CapType.COMMON]: 1,
    [CapType.RARE]: 2,
    [CapType.LEGENDARY]: 3
};

export const CollectionView = () => {
    const navigate = useNavigate();

    return (
        <ViewPopup
            query={collectionService.getById}
        >
            {(record) => (
                <>
                    <Typography
                        variant="body1"
                        sx={{fontWeight: "bold"}}
                        gutterBottom
                    >
                        <Label label="name"/>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {record.name}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{fontWeight: "bold"}}
                        gutterBottom
                    >
                        <Label label="season"/>
                    </Typography>
                    <Reference
                        queryKey="seasons"
                        query={seasonService.getById}
                        loader={<Skeleton/>}
                        recordId={record.season}
                    >
                        {(season) => (
                            <Typography variant="body1" gutterBottom>
                                {dayjs(season.startDate).format("DD.MM.YYYY")}
                            </Typography>
                        )}
                    </Reference>

                    <Query
                        queryKey={["caps", "list", "all", {collection: record.id}]}
                        queryFn={() => capService.getList({filter: {collection: record.id}})}
                        loader={
                            Array.from({length: 10}, (_, index) => (
                                <div key={index}>Элемент {index + 1}</div>
                            ))
                        }
                        error={(error) => <Typography>Error</Typography>}
                    >
                        {(data) => (
                            <>
                                <Typography
                                    variant="body1"
                                    sx={{fontWeight: "bold"}}
                                    gutterBottom
                                >
                                    <Label
                                        label="packAssetBundle"/> {`${(data?.length ?? 0)} (legendary: ${data?.filter(c => c.type == CapType.LEGENDARY).length ?? 0}, rare: ${data?.filter(c => c.type == CapType.RARE).length ?? 0} , common: ${data?.filter(c => c.type == CapType.COMMON).length ?? 0})`}
                                </Typography>

                                <Box sx={{display: "flex", flexDirection: "row", gap: "10px", flexWrap: "wrap"}}>
                                    <CapAddButton onClick={() => navigate("caps/create")}/>
                                    {data?.sort((a, b) => typeOrder[a.type] - typeOrder[b.type]).map((item, index) => (
                                        <Badge
                                            onClick={() => {
                                                navigate(`caps/${item.id}`)
                                            }}
                                            badgeContent={`${item.type.toString().toLowerCase().substring(0, 3)} ${item.category?.toString()?.toLowerCase()?.substring(0, 1) ?? ""}`}
                                            color="primary"
                                            key={item.id}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                        >
                                            <Avatar
                                                alt={item?.texture?.albedoTransparency?.title}
                                                src={item?.texture?.albedoTransparency?.src}
                                                sx={{width: 56, height: 56}}
                                            />
                                        </Badge>
                                    ))}
                                </Box>
                            </>
                        )}
                    </Query>
                </>
            )}
        </ViewPopup>
    );
};
